<template>
  <b-table
    :fields="fieldsInstrument"
    :items="instrumentRemains.results"
    show-empty
    responsive
    hover
    :empty-text="$t('empty_text')"
    @row-clicked="$emit('row-selected', $event)"
  >
    <template #head()="props">
      <span>{{ $t(props.label) }}</span>
    </template>
    
    <template #cell(remainder)="{ value }">
      <template v-if="value.length">
        <div v-for="(item, index) in value" :key="index">
          <span>{{ item.storage__title }}</span> -
          <span>{{ item.sum_remainder }}</span>
        </div>
      </template>
      <template v-else>
        <span>0</span>
      </template>
    </template>
    <template #cell(total_count)="{ item }">
      {{ $_formatPriceMixin(item.total_count) }}
    </template>
    <template #cell(actions)>
      <div>
        <b-button
          v-b-modal.modal-instrument-warehouse
          variant="outline-success"
          size="sm"
          class="mt-50 mb-50"
        >
          Поделиться
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
import { BTable, BButton } from "bootstrap-vue";
import { mapGetters, mapState } from "vuex";
import priceFormatMixin from '@/mixins/priceFormatMixin.js'

export default {
  components: {
    BTable,
    BButton,
  },
  mixins: [priceFormatMixin],
  data: () => ({
    fieldsInstrument: [
      {
        label: "№",
        key: "id",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "reference.categoriya",
        key: "type.category.title",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "courses.type",
        key: "type.title",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "reference.name",
        key: "title",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "amount",
        key: "total_count",
        thClass: "text-center",
        tdClass: "text-center",
      },
    ],
  }),
  computed: {
    ...mapState("instruments", ["instrumentRemains"]),
  },
};
</script>

<style>
</style>
